import { render, staticRenderFns } from "./VLayoutMiddle.vue?vue&type=template&id=408d0e75&"
import script from "./VLayoutMiddle.vue?vue&type=script&lang=js&"
export * from "./VLayoutMiddle.vue?vue&type=script&lang=js&"
import style0 from "./VLayoutMiddle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408d0e75')) {
      api.createRecord('408d0e75', component.options)
    } else {
      api.reload('408d0e75', component.options)
    }
    module.hot.accept("./VLayoutMiddle.vue?vue&type=template&id=408d0e75&", function () {
      api.rerender('408d0e75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VLayoutMiddle.vue"
export default component.exports